import cloneDeep from "lodash/cloneDeep";
import isEmpty from "lodash/isEmpty";
import { FORM_KEY } from "./constants/form";

const configToEntitlement = ({ uid, enabled, ...remainder }) => ({
  enabled: Boolean(enabled),
  ...remainder
});

export const featureProductConfigToEntitlements = ({ features }) =>
  features.reduce((memo, feature) => {
    memo[feature.uuid] = Array.isArray(feature.product_config)
      ? feature.product_config.reduce((innerMemo, pConf) => {
          innerMemo[pConf.uid] = configToEntitlement(pConf);

          return innerMemo;
        }, {})
      : Object.keys(feature.product_config).reduce((innerMemo, pConf) => {
          innerMemo[pConf.uid] = configToEntitlement(pConf);
          return innerMemo;
        }, {});
    return memo;
  }, {});

export const getEntitlementConfigTemplate = (props = {}) => ({
  enabled: false,
  value: "",
  description: "",
  ...props
});

export const removeFeatureGroupFromEntitlements = ({
  featureGroup,
  features,
  entitlements
}) => {
  const updatedEntitlements = cloneDeep(entitlements);
  const featureUUIDs = featureGroup.feature_uuids;
  if (featureUUIDs && featureUUIDs.length && features && features.length) {
    featureUUIDs.forEach((uuid) => {
      const featureMatch = features.find((feature) => feature.uuid === uuid);
      if (featureMatch) {
        updatedEntitlements &&
          updatedEntitlements[featureMatch.uuid] &&
          delete updatedEntitlements[featureMatch.uuid];
      }
    });
  }
  return updatedEntitlements;
};

export const getEntitlementFormIntialValues = (entitlement) => {
  const initialValues = !isEmpty(entitlement)
    ? cloneDeep(entitlement)
    : getEntitlementConfigTemplate();
  const limitVal = initialValues.limit;
  const maxVal = limitVal && limitVal.max;
  const hasLimit = !isEmpty(limitVal);

  initialValues[FORM_KEY] = {
    limit: hasLimit,
    link: hasLimit && `${maxVal}` === initialValues.value
  };

  return initialValues;
};
